import { Box, InputLabel, MenuItem, TextField } from '@mui/material'
import { styles } from './UserInformationCard.styles'

interface Props {
  name: string
  label: string
  value: string
  disabled?: boolean
  helperText?: string
  options?: string[]
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const ProfileField = (props: Props): JSX.Element =>
  <Box sx={styles.field}>
    <InputLabel id={`${props.name}-label`} htmlFor={props.name} sx={styles.fieldLabel}>{props.label}</InputLabel>

    <TextField
      id={props.name}
      name={props.name}
      value={props.value}
      variant='outlined'
      disabled={props.disabled}
      helperText={props.helperText}
      select={props.options != null}
      // A select renders a div[role=combobox], which htmlFor cannot name; only labelId reaches it.
      SelectProps={{ labelId: `${props.name}-label` }}
      onChange={props.onChange}
      data-testid={props.name}
      sx={styles.fieldInput}
    >
      {props.options != null && [
        <MenuItem key='' value=''><em>Not set</em></MenuItem>,
        ...props.options.map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)
      ]}
    </TextField>
  </Box>
